export type ChargeRuleGapStatus = "complete" | "missing" | "inactive" | "no_price";

export type ChargeRuleGapPriority = "required" | "recommended" | "conditional";

export interface ChargeRuleCoverageSlot {
  rule_type: string;
  pitch_category_id: string | null;
  pitch_category_name: string | null;
  guest_type: string | null;
  priority: ChargeRuleGapPriority;
  status: ChargeRuleGapStatus;
  rule_id: string | null;
  article_id: string | null;
  article_number: string | null;
  article_name: string | null;
  status_detail: string | null;
  note: string | null;
}

export interface ChargeRuleCoverage {
  slots: ChargeRuleCoverageSlot[];
  open_count: number;
  complete_count: number;
}

export const CHARGE_RULE_GAP_STATUS_LABELS: Record<ChargeRuleGapStatus, string> = {
  complete: "Zugeordnet",
  missing: "Fehlt",
  inactive: "Inaktiv",
  no_price: "Kein Preis",
};

export const CHARGE_RULE_GAP_PRIORITY_LABELS: Record<ChargeRuleGapPriority, string> = {
  required: "Pflicht",
  recommended: "Empfohlen",
  conditional: "Bedingt",
};

/** Vereinfachte Badge-Bezeichnung: Pflicht vs. alles andere */
export const CHARGE_RULE_PRIORITY_BADGE_LABELS: Record<"required" | "optional", string> = {
  required: "Pflicht",
  optional: "Optional",
};

export function chargeRulePriorityBadgeKey(
  priority: ChargeRuleGapPriority,
): keyof typeof CHARGE_RULE_PRIORITY_BADGE_LABELS {
  return priority === "required" ? "required" : "optional";
}

export function chargeRulePriorityBadgeLabel(priority: ChargeRuleGapPriority): string {
  return CHARGE_RULE_PRIORITY_BADGE_LABELS[chargeRulePriorityBadgeKey(priority)];
}

export function isOpenChargeRuleGap(status: ChargeRuleGapStatus): boolean {
  return status !== "complete";
}

export function isRequiredOpenChargeRuleSlot(slot: ChargeRuleCoverageSlot): boolean {
  return slot.priority === "required" && isOpenChargeRuleGap(slot.status);
}

export function countRequiredOpenChargeRuleSlots(slots: ChargeRuleCoverageSlot[]): number {
  return slots.filter(isRequiredOpenChargeRuleSlot).length;
}

export function chargeRuleSlotKey(slot: Pick<ChargeRuleCoverageSlot, "rule_type" | "pitch_category_id" | "guest_type">): string {
  return `${slot.rule_type}:${slot.pitch_category_id ?? "global"}:${slot.guest_type ?? "all"}`;
}
